import { useEffect, useState } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';

const useMsalInitialization = (msalInstance: PublicClientApplication) => {
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        const initializeMsal = async () => {
            await msalInstance.initialize();
            setInitialized(true);
        };

        initializeMsal();
    }, [msalInstance]);

    return initialized;
};

export default useMsalInitialization;